<template>
  <LazyCarousel
    v-if="colors"
    ref="container"
    :class="$style['carousel']"
    size="small"
    :active="activeIndex"
    :title="$t('general/filter-color')"
    :items="colors">
    <template #item="{ item }">
      <NuxtLink
        :key="item.name"
        replace
        :class="[
          $style['color-variations__item'],
          { [$style['color-variations__item--active']]: active === item.cId },
          {
            [$style['color-variations__item--unavailable']]: item.stock === 0
          }
        ]"
        :to="{
          name: `${$lang}-product-slug-id`,
          params: { id: item.cId, slug: item.slug }
        }">
        <img
          :alt="formattedAlt(item)"
          loading="lazy"
          decoding="async"
          :width="480"
          :height="768"
          :src="
            `${config.public.cdnURL}pictures/thumbs/${item.image}-thumbnail.webp`
          ">
        <span :class="$style['color-variations__item__name']">{{
          item.name
        }}</span>
      </NuxtLink>
    </template>
  </LazyCarousel>
</template>
<script setup>
const config = useRuntimeConfig()
const props = defineProps({
  product: {
    type: Object,
    default: null
  },
  active: {
    type: Number,
    default: null
  }, // Active id
  colors: {
    type: Array,
    default: null
  } // Coming from product.colorVariations
})

const activeIndex = computed(() => {
  return props.colors.findIndex(color => {
    return color.cId === props.active
  })
})

const formattedAlt = color => {
  return `${props.product.title} | ${color.name} | Guts & Gusto`
}

</script>
<style lang="scss" module>
.carousel {
  width: 100%;
}

.color-variations {
  position: relative;

  &__items {
    display: flex;
    position: relative;
  }

  &__item {
    aspect-ratio: 1 / 1;
    color: var(--grey-dark);
    display: flex;
    flex-direction: column;

    // font-weight: var(--font-weight-bold);
    margin-right: var(--spacing);
    scroll-snap-align: start;
    z-index: 1;
    width: 100%;
    text-decoration: none;

    &::after {
      aspect-ratio: 1/1;
      box-shadow: inset 0 0 0 2px var(--grey-light), inset 0 0 0 4px var(--white);
      border-radius: var(--border-radius);
      content: '';
      display: block;
      position: absolute;
      left: 0;
      right: 0;
    }

    &:hover:not(.color-variations__item--active),
    &:focus-visible {
      box-shadow:none;

      &::after {
        box-shadow: inset 0 0 0 2px var(--grey), inset 0 0 0 4px var(--white);
      }
    }

    img {
      border-radius: var(--border-radius);
      object-fit: cover;
      height: 100%;
      width: 100%;
      z-index: -1;

    }

    // &:active {
    //   img {
    //     opacity: 0.8;
    //   }
    // }

    &:hover {
      color: var(--black);
    }

    &__name {
      display: block;
      padding: var(--spacing) calc(var(--spacing) * 0.5);
      font-size: var(--font-size-s);
      line-height: var(--line-height);
      text-align: center;
      text-transform: capitalize;
      text-decoration: none;
      width: auto;
    }

    &--unavailable {
      opacity: 0.5;

      &:hover {
        opacity: 0.75;
      }
    }

    &--active {
      &::after {
        box-shadow: inset 0 0 0 2px var(--black), inset 0 0 0 4px var(--white);
      }

      &,
      &:hover {
        color: var(--black);
        opacity: 1;
      }
    }
  }
}
</style>
